import { FunctionComponent } from 'react';
import { IconButton, Dialog, Table, TableRow, TableCell } from '../../../../tailwindcomponents';
import { LinePackageOverviewObj } from '../../../../types/line';
import { TableColumns } from '../../../../types/table';
import { redirectToMxi } from '../../../../config/mxiProvider';
import { Link } from '../../../icons';
type StoppedPackagesDialogProps = {
  visible: boolean;
  packages: Array<LinePackageOverviewObj>;
  onClose: () => void;
};

const sortTableColumns = [
  { label: "MXI", key: "wo_barcode" },
  { label: "Tail", key: "tail_number" },
  { label: "Work Package", key: "wo_name" },
  { label: "Work type", key: "work_type_cd" },
  { label: "Wo number", key: "wo_number" },
  { label: "Work Package Status", key: "wo_status" },
  { label: "Start Date", key: "start_date_text" },
  { label: "Due Date", key: "due_date_text" },
] as TableColumns[];

const StoppedPackagesDialog: FunctionComponent<StoppedPackagesDialogProps> = ({
  visible,
  packages,
  onClose,
}) => {
  const generateStoppedPackagesTableBody = (row: LinePackageOverviewObj, index: number) => {
    return (
      <TableRow key={index}>
        <TableCell></TableCell>
        <TableCell onClick={() => redirectToMxi(row.wo_barcode)}>
          <IconButton><Link color="primary" /></IconButton>
        </TableCell>
        <TableCell>{row.tail_number}</TableCell>
        <TableCell>{row.wo_name}</TableCell>
        <TableCell>{row.work_type_cd}</TableCell>
        <TableCell>{row.wo_number}</TableCell>
        <TableCell>{row.wo_status}</TableCell>
        <TableCell>{row.start_date_text}</TableCell>
        <TableCell>{row.due_date_text}</TableCell>
      </TableRow>
    );
  };

  return (
    <Dialog
      visible={visible}
      max_width={"xl"}
      title={"Packages on hold"}
      context={
        <div>
          <Table
            rows={packages}
            generateBody={(row: LinePackageOverviewObj, index: number) => generateStoppedPackagesTableBody(row, index)}
            sortTableColumns={sortTableColumns}
          />
        </div>
      }
      onClose={() => onClose()}
      strict={false}
      show_options={false}
    />
  );
};

export default StoppedPackagesDialog;
